// @flow
const Logger = require('js-logger')

let sentryHandler = (_messages, _context) => true

if (process.env.REACT_APP_EXTERNAL !== 'true' && process.env.SENTRY === 'true') {
  import(/* webpackMode: "eager" */ 'services/sentry')
    .then(({ Sentry }) => {
      // eslint-disable-next-line no-console
      console.debug('Bind sentry service to logger')

      sentryHandler = (messages, context) => {
        const { level = { name: 'INFO' } } = context

        if (level.name === 'ERROR') {
          Sentry.loggerHandler(messages[0], { ...context, args: messages[1] || null })
        }
      }

      return true
    })
    .catch(error => console.error(error)) // eslint-disable-line
}

export function initLogger() {
  // eslint-disable-next-line no-console
  console.debug('Init logger')
  Logger.useDefaults()
  const consoleHandler = Logger.createDefaultHandler()

  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BETA !== 'true') {
    Logger.setLevel(Logger.INFO)
  } else {
    Logger.setLevel(Logger.DEBUG)
  }

  Logger.setHandler((messages, context) => {
    consoleHandler(messages, context)
    sentryHandler(messages, context)
  })

  return true
}

export { Logger }

export default Logger
